import { render, staticRenderFns } from "./ProductAdd.vue?vue&type=template&id=1ff8c8e0&"
import script from "./ProductAdd.vue?vue&type=script&lang=ts&"
export * from "./ProductAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports